import { Card } from '@nextui-org/react';
import React from 'react';
import Typography from './Typography';
import theme from '../../theme';

interface IReducedProductCard {
  productName: string;
  productDescription: string;
  price: string;
  selected?: boolean;
  recurringPeriod: string;
  onPress: () => void;
  reduced?: boolean;
}

export default function ReducedProductCard({
  reduced = false,
  price,
  productDescription,
  recurringPeriod,
  productName,
  selected,
  onPress
}: IReducedProductCard) {

  return (
    <Card
      shadow='none'
      disableRipple
      isPressable
      onPress={onPress}
      style={{border: `${selected ? 4 : 2}px solid ${selected ? theme.color.primary : theme.color.textLabel}`}}
      className='px-4 py-8 flex flex-row justify-between items-center gap-8'>
        <div className='flex flex-col items-start'>
          <Typography 
            variant='display'>
              {productName}
          </Typography>
          <Typography 
            variant='label' 
            style={{textAlign: 'left'}}
            colorVariant='textLabel'>
              {productDescription}
          </Typography>
          <div className='flex gap-1 items-center mt-4'>
            <Typography
              variant='headline2'>
                {price}
            </Typography>
            <Typography variant='headline3'>
              / {recurringPeriod}
            </Typography>
          </div>
        </div>
        {
          selected && !reduced &&  (
            <Typography 
              variant='button' 
              style={{fontWeight: 700}}
              colorVariant='primary'>
                SELEZIONATO
            </Typography>
          )
        }
    </Card>
  )
}